export default __webpack_public_path__ + "static/media/pic72.aef946d5.jpg";